import angular from 'angular';
import addChangeEventDialogTemplate from './AddChangeEventDialog.html';

/*----------------------------------------------------------------*/
/* Tab Content template IDs - These will be used to populate the  */
/* template cache so the tab content can be loaded with ngInclude */
/*----------------------------------------------------------------*/
/*-------------------*/
/* Items types tabs. */
/*-------------------*/
/** Tickets.   */ var TID_TICKETS = 'tickets.template.html';
/** Attendees. */ var TID_ATTENDEES = 'attendees.template.html';

/*-----------------------------------------------*/
/* Update the templateCache for the tab content. */
/*-----------------------------------------------*/
/* @ngInject */ export function runTemplateCache($templateCache) {
  $templateCache.put(TID_TICKETS, '<tickets></tickets>');
  $templateCache.put(TID_ATTENDEES, '<attendees></attendees>');
}

/****************************************************************************
 * Service: AddChangeEventDialog */
/**
 * @ngdoc     service
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.service:AddChangeEventDialog
 * @description
 * Modal dialog to add or manage existing event.
 *****************************************************************************/
/* @ngInject */ export function AddChangeEventDialogService($q, $uibModal, BusyScreen, Events, Tools) {
  /***************************************************************************
   * show */
  /**
   * @ngdoc     function
   * @name      show
   * @module    csm.books.eventsAdmin
   * @methodOf  csm.books.eventsAdmin.service:AddChangeEventDialog
   * @param    id           ID of event to modify. Null/0=Add new event.
   * @param    newEvent     Object for new a event expected from SelectEventType
   *                        dialog with 3 properties set; id, openEvent & grades.
   * @param    readOnly     Boolean indication to prevent modifying the event.
   * @return   {Promise}    Resolves upon close.
   * @description
   * Handles adding/modifying an event
   ***************************************************************************/
  this.show = function (id, newEvent, readOnly) {
    var isNew = Tools.isNaNZero(id);

    /*-------------------------------------------------*/
    /* Load the event details and attendees for the    */
    /* given event ID, load the product list and check */
    /* if the user is allowed to view/add tickets.     */
    /*-------------------------------------------------*/
    BusyScreen.setBusy(true);
    return $q
      .all([
        !isNew ? Events.get(id) : newEvent,
        !isNew ? Events.getAttendees(id) : [],
        Events.getProductList(),
        Events.allowTickets()
      ])
      .then(function (resp) {
        BusyScreen.setBusy(false);
        return $uibModal.open({
          animation: false,
          backdrop: 'static',
          component: 'addChangeEventDialog',
          size: 'lg',
          resolve: {
            event: function () {
              return resp[0];
            },
            attendees: function () {
              return resp[1];
            },
            productList: function () {
              return resp[2] || [];
            },
            allowTickets: function () {
              return resp[3];
            },
            isNew: function () {
              return isNew;
            },
            readOnlyMode: function () {
              return readOnly;
            }
          }
        }).result;
      });
  };
}

/*****************************************************************************
 * Component: addChangeEventDialog */
/**
 * @ngdoc     component
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.component:addChangeEventDialog
 * @param  {Object} modalInstance $uibModal instance from $uibModal.open method
 * @param  {Object} resolve       Resolve object passed from $uibModal.open method
 * @description
 * Display dialog to add or modify existing event.
 *****************************************************************************/
export const addChangeEventDialogComponent = {
  template: addChangeEventDialogTemplate,
  bindings: { modalInstance: '<', resolve: '<' },
  controller: Controller
}

/*****************************************************************************
 * Controller: Controller */
/**
 * @ngdoc     controller
 * @module    csm.books.eventsAdmin
 * @methodof  csm.books.eventsAdmin.addChangeEventDialog
 * @description
 * Controller for the addChangeEventDialog component.
 *****************************************************************************/
/* @ngInject */ function Controller($injector) {
  var $ctrl = this;
  $ctrl.$onInit = $injector.invoke($onInit, null, { $ctrl: $ctrl });
  $ctrl.saveEvent = $injector.invoke(saveEvent, null, { $ctrl: $ctrl });

  /*-------------------------------------*/
  /* Tab Objects - Default the onSelect  */
  /* property to use the empty function. */
  /*-------------------------------------*/
  $ctrl.tabTickets = {
    header: 'Tickets',
    onSelect: angular.noop,
    templateUrl: TID_TICKETS
  };
  $ctrl.tabAttendees = {
    header: 'Attendees',
    onSelect: angular.noop,
    templateUrl: TID_ATTENDEES
  };

  /*-----------------*/
  /* Tabbed content. */
  /*-----------------*/
  $ctrl.tabs = [];
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc    function
 * @module   csm.books.eventsAdmin
 * @methodOf csm.books.eventsAdmin.addChangeEventDialog.controller:Controller
 * @description
 * Called by angular when the component is ready. This will set up some
 * properties from the bound values.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl) {
  return function () {
    /** Event Object. */ $ctrl.event = $ctrl.resolve.event;
    /** Event Attendees. */ $ctrl.dpAttendees = $ctrl.resolve.attendees;
    /** Product List. */ $ctrl.productList = $ctrl.resolve.productList;
    /** Tickets Access Indicator. */ $ctrl.allowTickets =
      $ctrl.resolve.allowTickets;
    /** New Event Indicator. */ $ctrl.isNew = $ctrl.resolve.isNew;
    /** Prevent modifications. */ $ctrl.readOnlyMode =
      $ctrl.resolve.readOnlyMode;
    /** Validator Object. */ $ctrl.validators = {};

    /*-----------------------------*/
    /* Shuttle List dataproviders. */
    /*-----------------------------*/
    $ctrl.dpProducts;
    $ctrl.dpTickets;

    /*----------------------*/
    /* Set the modal title. */
    /*----------------------*/
    $ctrl.title = $ctrl.isNew
      ? 'Add New ' + ($ctrl.event.openEvent ? 'Open' : 'Ticketed') + ' Event'
      : $ctrl.readOnlyMode
        ? 'Event Details'
        : 'Change Event';

    /*---------------------------------------*/
    /* Autoselect the first tab in the list. */
    /*---------------------------------------*/
    $ctrl.activeTab = 0;

    /*--------------------------------------------------*/
    /* Populate the list of available tabs. The tickets */
    /* tab is only available on ticketed events and     */
    /* when the user is allowed to view tickets.        */
    /*--------------------------------------------------*/
    $ctrl.tabs.push($ctrl.tabAttendees);
    if ($ctrl.allowTickets && !$ctrl.event.openEvent)
      $ctrl.tabs.push($ctrl.tabTickets);

    /*---------------------------------*/
    /* Exisiting tickets on the event. */
    /*---------------------------------*/
    var tickets = $ctrl.event.tickets || [];

    /*----------------------------------------------*/
    /* Load the Available Products Shuttle List     */
    /* dataprovider with the products that have not */
    /* been added to the product, sorted by name.   */
    /*----------------------------------------------*/
    $ctrl.dpProducts = $ctrl.productList
      .filter(function (pli) {
        return tickets.indexOf(pli.id) == -1 && pli.active;
      })
      .sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });

    /*---------------------------------------------------------*/
    /* Load the Current Tickets Shuttle List dataprovider with */
    /* those products already added to the event as tickets.   */
    /*---------------------------------------------------------*/
    $ctrl.dpTickets = $ctrl.productList.filter(function (pli) {
      return tickets.indexOf(pli.id) > -1;
    });

    /*---------------------------------------------------------*/
    /* Create references to the modal dismiss & close methods. */
    /*---------------------------------------------------------*/
    $ctrl.dismiss = $ctrl.modalInstance.dismiss;
    $ctrl.close = $ctrl.modalInstance.close;
  };
}

/*****************************************************************************
 * saveEvent */
/**
 * @ngdoc    function
 * @module   csm.books.eventsAdmin
 * @methodOf csm.books.eventsAdmin.addChangeEventDialog.controller:Controller
 * @param  {Boolean} reopenDialog  Indication not to close the modal window
 *                                 on successful save.
 * @description
 * Save event then close dialog.
 *****************************************************************************/
/* @ngInject */ function saveEvent($ctrl, $q, Alert, BusyScreen, Events) {
  return function (reopenDialog) {
    /*----------------------------*/
    /* Modifications not allowed. */
    /*----------------------------*/
    if ($ctrl.readOnlyMode) return;

    /*------------------------------------*/
    /* Clear alerts and reset validators. */
    /*------------------------------------*/
    Alert.clear();
    $ctrl.validators.reset();

    /*---------------------------------*/
    /* Validate required input fields. */
    /*---------------------------------*/
    if (!$ctrl.validators.validate()) return $q.reject();

    /*--------------------------------------------------*/
    /* Prevent sales date that is after the event date. */
    /*--------------------------------------------------*/
    if ($ctrl.event.date && $ctrl.event.salesDate)
      if ($ctrl.event.date < $ctrl.event.salesDate) {
        Alert.error(
          'Sales From date cannot be after the event date.',
          'Date Error'
        );
        return $q.reject();
      }

    /*---------------------------------------*/
    /* Save the IDs of the selected products */
    /* as tickets on the event object.       */
    /*---------------------------------------*/
    $ctrl.event.tickets = $ctrl.dpTickets.map(function (ticket) {
      return ticket.id;
    });

    /*---------------------------------------------------*/
    /* Verify theres at least one grade for open events. */
    /*---------------------------------------------------*/
    if ($ctrl.event.openEvent)
      if ($ctrl.event.gradesList.split(',') < 1)
        return Alert.error('No grades selected.');

    /*--------------------*/
    /* Proceed with save. */
    /*--------------------*/
    BusyScreen.setBusy(true);
    return Events.save($ctrl.event)
      .then(
        function (resp) {
          $ctrl.event.id = resp;

          /*-------------------------------------------*/
          /* Close and send an object back with the    */
          /* Event ID and a flag to reopen the dialog. */
          /*-------------------------------------------*/
          Alert.success('Event saved.');
          $ctrl.close({ id: resp, reopenDialog: reopenDialog });
        },
        function (resp) {
          Alert.error(resp.parsedResponse.message(), 'Save Failed');
          return $q.reject();
        }
      )
      .finally(function () {
        BusyScreen.setBusy(false);
      });
  };
}
